module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "niceDate",
      "label": "Created",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file",
      "label": "Zip Name",
      "min-width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nskProcessed",
      "label": "Imported from NSK",
      "min-width": "230",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nskCount",
      "label": "NSK#",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sqsCount",
      "label": "SQS#",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sqsProcessed",
      "label": "Saved in Jits",
      "min-width": "230",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Show Load Details",
      "visible": _vm.editFormVisible,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "140px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "MAIN"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Load Status")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "white",
      "margin": "0 0 7px 0",
      "padding": "5px",
      "width": "100%",
      "background": "#999"
    }
  }, [_c('center', [_vm._v("Imported from NSK")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Imported : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['niceDate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'niceDate', $$v)
      },
      expression: "editForm['niceDate']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip File : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['file']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'file', $$v)
      },
      expression: "editForm['file']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Processed : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['nskProcessed']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'nskProcessed', $$v)
      },
      expression: "editForm['nskProcessed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Records/Sqs# : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['nskCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'nskCount', $$v)
      },
      expression: "editForm['nskCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['sqsCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sqsCount', $$v)
      },
      expression: "editForm['sqsCount']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "white",
      "margin": "7 0 7px 0",
      "padding": "5px",
      "width": "100%",
      "background": "#999"
    }
  }, [_c('center', [_vm._v("Saved in Jits DB")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Saved On : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['sqsProcessed']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sqsProcessed', $$v)
      },
      expression: "editForm['sqsProcessed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Add/Mod/Del/Skip : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbAddCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbAddCount', $$v)
      },
      expression: "editForm['dbAddCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbModCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbModCount', $$v)
      },
      expression: "editForm['dbModCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbDelCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbDelCount', $$v)
      },
      expression: "editForm['dbDelCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbSkipCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbSkipCount', $$v)
      },
      expression: "editForm['dbSkipCount']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Unique Dossiers : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dossierCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dossierCount', $$v)
      },
      expression: "editForm['dossierCount']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Has Errors : "
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "xstyle": "width:20%"
    },
    model: {
      value: (_vm.editForm['hasErrors']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'hasErrors', $$v)
      },
      expression: "editForm['hasErrors']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "name": "DOSSIERS"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Dossiers")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "20",
      "cols": "100"
    },
    model: {
      value: (_vm.loadDossiers),
      callback: function($$v) {
        _vm.loadDossiers = $$v
      },
      expression: "loadDossiers"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "name": "ERRORS"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Errors")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "20"
    },
    model: {
      value: (_vm.loadErrors),
      callback: function($$v) {
        _vm.loadErrors = $$v
      },
      expression: "loadErrors"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f75606a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dbc/dbcload.vue
// module id = 653
// module chunks = 1